import API from "Signups/FamilyRegistration/API";
import { useFamilyRegistrationContext } from "Signups/FamilyRegistration/FamilyRegistrationContext";
import familyRegActions from "./actions";
import { useCallback, useMemo } from "react";

/** Fetches getAdminSettings and pushes entire response into context as such. */
const useFetchAdminSettings = () => {
  const { dispatch } = useFamilyRegistrationContext();
  const fetchAdminSettings = useCallback(() => {
    API.getAdminSettings()
      .post()
      .then((resp) => {
        dispatch(familyRegActions.setAdminSettings(resp));
      })
      .catch((err) => console.log({ err }));
  }, [dispatch]);

  return fetchAdminSettings;
};

const useEveryoneGroupID = () => {
  const {
    state: { everyoneGroupID: everyoneGroupIDRaw },
  } = useFamilyRegistrationContext();

  const everyoneGroupID = useMemo(
    () => everyoneGroupIDRaw,
    [everyoneGroupIDRaw]
  );

  return [everyoneGroupID];
};

const familyRegStateHooks = { useFetchAdminSettings, useEveryoneGroupID };

export default familyRegStateHooks;
